import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export class FormMessages extends PureComponent {
  renderChildren(children, field, errorCount) {
    const error = field && (field.meta && field.meta.error);
    const touched = field && (field.meta && field.meta.touched);
    if (touched && error) {
      const errorList = React.Children.toArray(children)
        .filter(child => child.props.when && error[child.props.when]);

      const displayErrorCount = parseInt(errorCount, 10);
      if (displayErrorCount < 0) {
        return errorList;
      }
      return errorList.slice(0, displayErrorCount);
    }
    return null;
  }

  render() {
    const { children, field, errorCount } = this.props;
    return (
      <>
        { this.renderChildren(children, field, errorCount)}
      </>
    );
  }
}

FormMessages.propTypes = {
  children: PropTypes.array,
  field: PropTypes.object.isRequired,
  tagName: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  errorCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

FormMessages.defaultProps = {
  errorCount: -1,
  tagName: 'div',
};
